// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PoDCampaign-module__PoDCampaign___X82KR {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}
`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/PoDCampaign.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB","sourcesContent":[".PoDCampaign {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PoDCampaign": `PoDCampaign-module__PoDCampaign___X82KR`
};
export default ___CSS_LOADER_EXPORT___;
